import { render, staticRenderFns } from "./pipClassRoom.vue?vue&type=template&id=13ba7838&scoped=true&"
import script from "./pipClassRoom.vue?vue&type=script&lang=js&"
export * from "./pipClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./pipClassRoom.vue?vue&type=style&index=0&id=13ba7838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ba7838",
  null
  
)

export default component.exports